module.exports = __webpack_public_path__ + "assets/img/KT.6077fcab.png";